var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"canvas-box"},[_c('canvas',{ref:"radarChart",staticClass:"rating-canvas",attrs:{"width":_vm.cavsWidth,"height":_vm.cavsHeight}})])}
var staticRenderFns = []

export { render, staticRenderFns }